import { useNavigate } from 'react-router-dom';
import { CardNotice } from 'components/CardNotice';
import { ImageCarousel } from 'components/ImageCarousel';
import { Section } from 'components/Section';
import { SliderComments } from 'components/SliderComments';
import { useSpaProvider } from 'hooks/spaRouterContext';
import { Container } from './styles';
import { sectionsIncorporators, sectionsProprietary } from './textPrototype'
import { LinkCard } from 'components/Card/types';
import Skeleton from 'react-loading-skeleton';
import { useScreenWidth } from 'utils/useScreenWidth';
import MobileCarouselProperties from 'components/MobileCarouselProperties';
import MobileCarouselComments from 'components/MobileCarouselComments';
import * as S from './styles'
import { useAnyProvider } from 'hooks/Context';
import { WhatsappButton } from 'components/WhatsappButton';


type BodyProps = {
  accommodations: any;
  buildings: any;
  blog: any;
  isFetching: boolean
}

export const comments = [
  {
    comment: '“Recomento bastante! Tive uma experiência muito positiva, bem organizado, limpo e com profissionais muito simpáticos. Paraquem busca uma boa hospedagem em Curitiba, pode confiar”.',
    user: 'Joaldo',
    reference: 'Morador, pelo airbnb',
  },
  {
    comment: '“Adorei a hospedagem e com certeza ficarei mais vezes! Fomos muito bem recebidos, lugar organizado e limpo, arredores com muita coisa pra fazer, em um bairro nobre de Curitiba! Recomendo”.',
    user: 'Maristela',
    reference: 'Moradora, pelo airbnb',
  },
  {
    comment: '"Ótima estadia! O cheirinho de limpeza ficou até o último dia. A vista é maravilhosa e o anfitrião responde as dúvidas prontamente. Pessoal da portaria também é bastante solícito e educado. Tudo muito bom! Voltarei assim que possível!”.',
    user: 'Viviane',
    reference: 'Moradora, pelo airbnb',
  }
]

export const Body = ({ accommodations, buildings, blog, isFetching }: BodyProps) => {

  const { setExpanded, setPageChosen } = useSpaProvider();

  const navigate = useNavigate();

  const { setSearchType, setSearchValue } = useAnyProvider()

  const breakpoint = useScreenWidth()

  const accomodationsLink: LinkCard = {
    image: require('assets/svg/Percent.svg').default,
    buttonText: 'Ver ofertas',
    linkText: "Conheça todas as nossas ofertas",
    size: 'unit',
    id: 'all',
    onClick: () => openHeaderPromo()
  }

  const openHeader = () => {
    if (breakpoint) {
      navigate('/search-location')
      setPageChosen(2)
    } else {
      setTimeout(() => {
        setExpanded(false)
      }, 10);
      setTimeout(() => {
        setPageChosen(2)
      }, 50);
    }

  }
  const openHeaderPromo = () => {
    if (breakpoint) {
      navigate('/properties?search=Curitiba')
      setSearchValue('Curitiba')
      setSearchType('city')
    } else {
      setTimeout(() => {
        setExpanded(false)
      }, 10);
      setTimeout(() => {
        setPageChosen(1)
      }, 50);
    }

  }

  const buildingLink: LinkCard = {
    image: require('assets/svg/Units.svg').default,
    buttonText: 'Ver ofertas',
    linkText: "Conheça todas as unidades",
    size: 'unit',
    id: 'unit',
    onClick: openHeader
  }

  const accomodationsWithLink = [...accommodations, accomodationsLink]
  const buildingsWithLink = [...buildings, buildingLink]


  const blogLink: LinkCard = {
    image: require('assets/svg/NewBlogNotices.svg').default,
    id: 'blog',
    size: 'post',
    linkText: 'Quer acompanhar essas e outras matérias?',
    buttonText: 'Visitar blog',
    onClick: () => window.location.href = `https://blog.yogha.com.br/`
  }

  const postsWithLink = [...blog, blogLink]
  const notices = [
    {
      title: 'Moradia Flexível',
      description: 'Uma forma de morar descomplicada. Encontre o apê que é a sua cara e fique o tempo que quiser. ',
      icon: require('assets/svg/MapPin.svg').default,
      onClick: () => navigate('/moradia-flexivel/')
    },
    {
      title: 'Para proprietários',
      description: 'Obtenha a máxima rentabilidade com o seu imóvel sem sair de casa com o Yogha Gestão.',
      icon: require('assets/svg/UsersThree.svg').default,
      onClick: () => navigate('/proprietarios/')
    },
    {
      title: 'Para incorporadoras',
      description: 'Transforme o seu empreendimento em um prédio inteligente com o ecossistema Yogha',
      icon: require('assets/svg/Briefcase.svg').default,
      onClick: () => navigate('/incorporadores/')
    },
  ]

  const image = [
    {
      icon: require('assets/image/notices/InicialModalNews1.webp'),
      onClick: () => navigate('/moradia-flexivel/')
    },
    {
      icon: require('assets/image/notices/InicialModalNews2.webp'),
      onClick: () => navigate('/proprietarios/')
    },
    {
      icon: require('assets/image/notices/InicialModalNews3.webp'),
      onClick: () => navigate('/moradia-flexivel/')
    },
  ]

  const imageMobile = [
    {
      icon: require('assets/image/notices/MobileNews1.webp'),
      onClick: () => navigate('/moradia-flexivel/')
    },
    {
      icon: require('assets/image/notices/MobileNews2.webp'),
      onClick: () => navigate('/proprietarios/')
    },
    {
      icon: require('assets/image/notices/MobileNews3.webp'),
      onClick: () => navigate('/moradia-flexivel/')
    }
  ]


  return (
    <Container>
      {isFetching ? (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <Skeleton width={1208} borderRadius={16} height={490} />
          <Skeleton width={160} borderRadius={10} height={48} style={{
            marginBlock: '24px 52px'
          }} />
          <div style={{
            display: 'flex',
            gap: 32,
            marginBottom: 85
          }}>
            {Array.from({ length: 3 }).map((_, index) => {
              return <Skeleton key={index} borderRadius={10} width={380} height={165} />
            })}
          </div>
          <div style={{
            width: 1206
          }}>
            <Skeleton width={310} borderRadius={10} height={28} style={{
              marginBlock: '34px 16px',
              justifySelf: 'flex-start'
            }} />
          </div>

          <div style={{
            display: 'flex',
            gap: 32,
            maxWidth: 1208,
            overflow: 'hidden',
            marginBottom: 84
          }}>

            {
              Array.from({ length: 4 }).map((_, index) => {
                return (
                  <div key={index}>

                    <Skeleton width={310} borderRadius={10} height={192} />
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 14,
                      marginTop: 22
                    }}>
                      <Skeleton width={228} borderRadius={10} height={13} />
                      <Skeleton width={142} borderRadius={10} height={13} />
                    </div>
                    <div style={{
                      display: 'flex',
                      gap: 14,
                      flexDirection: 'column',
                      marginTop: 22
                    }}>
                      <Skeleton width={118} borderRadius={10} height={16} />
                      <Skeleton width={185} borderRadius={10} height={13} />
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>

      ) : (
        <>
          <div style={{ alignSelf: 'center' }}>
            <CardNotice notices={notices} imageNotice={breakpoint ? imageMobile : image} />
          </div>
          <S.CarouselContainer>
            {breakpoint && <S.TitleCarrousel>
              Oportunidades em destaque
            </S.TitleCarrousel>}
            {breakpoint ? <MobileCarouselProperties hasFrom link card='unit' data={accomodationsWithLink} titleCarousel='Oportunidades em destaque' type='default' /> : <ImageCarousel type='default' key={'unit'} card={'unit'} link titleCarousel='Oportunidades em destaque' hasFrom data={accomodationsWithLink} />}
          </S.CarouselContainer>
          <Section {...sectionsProprietary} onClick={() => navigate('/proprietarios/')} />
          <S.CarouselContainer style={{ marginTop: 20 }}>
            {breakpoint && <S.TitleCarrousel>
              Conheça as unidades Yogha
            </S.TitleCarrousel>}
            {breakpoint ? <MobileCarouselProperties hasFrom link card='building' data={buildingsWithLink} titleCarousel='Conheça as unidades Yogha' type='unit' /> : <ImageCarousel hasFrom type='unit' card='building' titleCarousel='Conheça as unidades Yogha' link data={buildingsWithLink} />}
          </S.CarouselContainer>
          <Section {...sectionsIncorporators} onClick={() => navigate('/incorporadores/')} />
          <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center', width: '100%', backgroundColor: '#f6f4f4' }}>
            {breakpoint ? <MobileCarouselComments comments={comments} /> : <SliderComments comments={comments} />}
          </div>
          <S.CarouselContainer style={{ marginBottom: 10, marginTop: 80 }}>
            {breakpoint && <S.TitleCarrousel>
              Blog da Yogha
            </S.TitleCarrousel>}
            {breakpoint ? <MobileCarouselProperties link card='post' data={postsWithLink} titleCarousel='Blog da Yogha' type='post' /> : <ImageCarousel type='post' link card='post' titleCarousel='Blog da Yogha' data={postsWithLink} />}
          </S.CarouselContainer>
        </>
      )}
      <WhatsappButton />
    </Container>
  )
}

